// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TableOutlinedSvg from "@ant-design/icons-svg/es/asn/TableOutlined";
import AntdIcon from '../components/AntdIcon';

var TableOutlined = function TableOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TableOutlinedSvg
  }));
};

TableOutlined.displayName = 'TableOutlined';
export default React.forwardRef(TableOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/TableOutlined.js
// module id = 1903
// module chunks = 0